import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Force React to register the Push Notification Service Worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    console.log('Service Worker registered successfully:', registration.scope);
  }).catch((err) => {
    console.log('Service Worker registration failed:', err);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);